export const calculateEcart = (totalFacture,timbre, tva, montantAchat) => {
    if (totalFacture,timbre, tva, montantAchat) {

        let totalFacturee = parseFloat(totalFacture);
        let timbree = parseFloat(timbre);
        let tvaa = parseFloat(tva);
        let montantAchatt = parseFloat(montantAchat);

        let ecart = ((totalFacturee + timbree + tvaa ) - montantAchatt);
        ecart = ecart.toFixed(3); 
        return parseFloat(ecart);
    }
};